/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EnrollmentPreviewRequestWaterfallStrategy } from './enrollmentPreviewRequestWaterfallStrategy';

/**
 * Body for ``POST /api/jobs/{job_id}/sequences/{seq_id}/enroll/preview``.
 *
 * ``sequence_id`` is in the body in addition to the URL so the
 * Configure modal can build the request from one struct and post
 * it; the route still validates URL-vs-body equality.
 */
export interface EnrollmentPreviewRequest {
  /**
     * @minItems 1
     * @maxItems 50
     */
  job_candidate_ids: string[];
  waterfall_strategy: EnrollmentPreviewRequestWaterfallStrategy;
  sequence_id: string;
}
